import {UiComponentBaseSchema} from "./UiComponent";
import {z} from "zod";

export const UiReferenceFieldBaseSchema = UiComponentBaseSchema.extend({
    referenceDefinitionId: z.string(),
    placeholder: z.string().optional(),
    helperText: z.string().optional(),
    readOnly: z.boolean().optional(),
});

export const UiReferenceFieldSchema = z.lazy(() => {
    const {SmartReferenceListFieldSchema} = require("./SmartReferenceListField");
    const {SmartReferenceSelectFieldSchema} = require("./SmartReferenceSelectField");

    return z.discriminatedUnion('componentType', [
        SmartReferenceListFieldSchema,
        SmartReferenceSelectFieldSchema,
    ]);
});

export type UiReferenceField = z.infer<typeof UiReferenceFieldSchema>;
